import React from "react";
import Image from "../../Tags/Image";

export default function FeaturesAndCapabilities({ data = {} }) {
  const makeLink = (link) => {
    if (link && link.charAt(0) === "/") {
      return `https://${data?.domain}${link}`;
    } else {
      return link;
    }
  };
  const CardLink = ({ heading, link, icon = "" }) => (
    <div className="border rounded-[14px] overflow-hidden border-input  bg-gray-100 relative p-4 w-[48.5%] inline-block mr-[1.5%] mb-[1%]">
      <div className="flex items-center">
        {/* {icon && <img src={icon} className="mr-3 no-invert" />} */}
        <Image src="/images/ext/companyinfo/code.svg" className="mr-3 no-invert" />
        <div className="inline-flex">
          <span className="text-[16px] text-gray-900 block">{heading}</span>

          {makeLink(link) && (
            <a href={makeLink(link)} target="_blank" className="ml-2">
              {" "}
              <Image className="no-invert" src="/images/ext/crm/hyperlink.svg" />
            </a>
          )}
        </div>
      </div>
    </div>
  );
  return (
    <div className="border rounded-[14px] overflow-hidden border-border  bg-background relative mt-4 p-4 pb-1">
      <div className="mb-4">
        <span className="text-[16px] text-text-700 mr-3 font-bold">Capabilities</span>
        <span className="block text-sm">Explore additional features and services offered</span>
      </div>
      <div className="mt-3 -mr-3">
        {/* <div className="border rounded-[14px] overflow-hidden border-input  bg-gray-100 relative px-4 py-3 w-[48.5%] inline-flex mr-[1.5%] mb-[1.7%] justify-between">
          <div className="inline-flex items-center space-x-2">
            <Image className="no-invert" src="/images/ext/mobile-apps.svg" />{" "}
            <span className="text-[16px] text-gray-900 block">Mobile App</span>
          </div>
          {data?.has_mobile_apps ? (
            <Image className="no-invert" src="/images/ext/check-purple.svg" width={20} height={20} />
          ) : (
            <Image className="no-invert" src="/images/ext/cross-black-circle.svg" width={20} height={20} />
          )}
        </div>
        <div className="border rounded-[14px] overflow-hidden border-input  bg-gray-100 relative px-4 py-3 w-[48.5%] inline-flex mr-[1.5%] mb-[1.7%] justify-between">
          <div className="inline-flex items-center space-x-2">
            <Image className="no-invert" src="/images/ext/desktop-apps.svg" />{" "}
            <span className="text-[16px] text-gray-900 block">
              Desktop App
            </span>
          </div>
          {data?.has_desktop_apps ? (
            <Image className="no-invert" src="/images/ext/check-purple.svg" width={20} height={20} />
          ) : (
            <Image className="no-invert" src="/images/ext/cross-black-circle.svg" width={20} height={20} />
          )}
        </div> */}
        {data && data?.user_login_url && (
          <CardLink heading="Login" link={data?.user_login_url} icon="/images/ext/companyinfo/signup.svg" />
        )}
        {data && data?.user_signup_url && (
          <CardLink heading="Signup" link={data?.user_signup_url} icon="/images/ext/companyinfo/signup.svg" />
        )}
        {data && data?.pricing_page_url && (
          <CardLink heading="Pricing" link={data?.pricing_page_url} icon="/images/ext/pricing.svg" />
        )}

        {data && data?.careers_page_url && (
          <CardLink heading="Careers" link={data?.careers_page_url} icon="/images/ext/career.svg" />
        )}
        {data && data?.blog_url && (
          <CardLink heading="Blog" link={data?.blog_url} icon="/images/ext/api-docs.svg" />
        )}
        {data && data?.newsletters_urls && typeof data?.newsletters_urls === "string" && (
          <CardLink heading="Newsletters" link={data?.newsletters_urls} />
        )}
        {data &&
          data?.newsletters_urls &&
          Array.isArray(data?.newsletters_urls) &&
          data?.newsletters_urls.length > 0 && (
            <CardLink heading="Newsletters" link={data?.newsletters_urls[0]} />
          )}

        {data && data?.support_portal_url && (
          <CardLink heading="Support Portal" link={data?.support_portal_url} />
        )}

        {data && data?.community_portal_url && (
          <CardLink
            heading="Community"
            link={data?.community_portal_url}
            icon="/images/ext/companyinfo/community.svg"
          />
        )}
        {data && data?.status_page_url && (
          <CardLink heading="Status" link={data?.status_page_url} icon="/images/ext/companyinfo/status.svg" />
        )}

        {data && data?.api_docs_urls && data?.api_docs_urls.length > 0 && (
          <>
            <div className="border rounded-[14px] overflow-hidden border-input  bg-gray-100 relative p-4 w-[48.5%] inline-block mr-[1.5%] mb-[1%]">
              <div className="flex items-center">
                <Image src="/images/ext/companyinfo/code.svg" className="mr-3 no-invert" />
                <div className="inline-flex">
                  <span className="text-[16px] text-gray-900 block">API Docs Urls</span>

                  {makeLink(data?.api_docs_urls[0]) && (
                    <a href={makeLink(data?.api_docs_urls[0])} target="_blank" className="ml-2">
                      {" "}
                      <Image className="no-invert" src="/images/ext/crm/hyperlink.svg" />
                    </a>
                  )}
                </div>
              </div>
              {/* <div className="flex items-center">
                <img src={"images/api-docs.svg"} className="mr-3 no-invert" />
                <div className="inline-flex flex-col">
                  <span className="text-[16px] text-gray-900 block">
                    API Docs Urls
                  </span>
                  {data?.api_docs_urls.map((url) => (
                    <a
                      href={url}
                      className="text-[12px] text-text-700 block"
                      target="_blank"
                    >
                      {url}
                    </a>
                  ))}
                </div>
              </div> */}
            </div>
          </>
        )}
      </div>
    </div>
  );
}
